import Category from '@/models/Category';
import { AxiosError } from 'axios';

export enum CategoryTypes {
    GET_CATEGORIES_CLEAR = '@category/GET_CATEGORIES_CLEAR',
    GET_CATEGORIES_REQUEST = '@category/GET_CATEGORIES_REQUEST',
    GET_CATEGORIES_SUCCESS = '@category/GET_CATEGORIES_SUCCESS',
    GET_CATEGORIES_FAILURE = '@category/GET_CATEGORIES_FAILURE',
    GET_CATEGORY_REQUEST = '@category/GET_CATEGORY_REQUEST',
    GET_CATEGORY_SUCCESS = '@category/GET_CATEGORY_SUCCESS',
    GET_CATEGORY_FAILURE = '@category/GET_CATEGORY_FAILURE',
    GET_CATEGORY_CLEAR = '@category/GET_CATEGORY_CLEAR',
    TOGGLE_CATEGORY = '@category/TOGGLE_CATEGORY',
    SET_SELECTED_CATEGORIES = '@category/SET_SELECTED_CATEGORIES',
}

export interface Categories {
    categories: Category[];
    categoriesTotalCountOfRegisters: number;
    selectedCategories: Category[];
    category: Category;
}

export interface CategoriesState {
    data: Categories;
    loading: boolean;
    hasError: boolean;
    error?: AxiosError;
}
